import SumsubWebSdk from '@sumsub/websdk-react'
import { kycApi } from '@/lib/auth-api'

interface KycSdkEmbedProps {
  accessToken: string
  lang: string
  onComplete?: () => void
  onError?: (error: unknown) => void
}

/**
 * Wraps the Sumsub WebSDK. The expiration handler transparently mints a fresh
 * access token via /kyc/start when the current one lapses mid-flow.
 */
export function KycSdkEmbed({ accessToken, lang, onComplete, onError }: KycSdkEmbedProps) {
  return (
    <SumsubWebSdk
      accessToken={accessToken}
      expirationHandler={async () => {
        const res = await kycApi.start()
        return res.access_token
      }}
      config={{ lang }}
      options={{ addViewportTag: false }}
      onMessage={(type: string) => {
        if (type === 'idCheck.onApplicantSubmitted' || type === 'idCheck.applicantStatus') {
          onComplete?.()
        }
      }}
      onError={(error: unknown) => onError?.(error)}
    />
  )
}
